// extracted by mini-css-extract-plugin
export default {"controls-wrapper":"controls-wrapper__M7fKr","nav-control-button":"nav-control-button__5XSl2","action-control-button":"action-control-button__yhT19"};